import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardHeader, CardTitle } from '@cargomatic/ui';
import { useTranslation } from 'react-i18next';
import VendorPayablesTable from 'components/modules/orders/order-rtb/VendorPayablesTable';
import formatMoney from 'utils/formatters/Money';
export default function VendorPayables({ charges, total, shipmentId, shipment, showConfirmation, isLegManagementEnabled = false, }) {
    const { t } = useTranslation();
    // Transform charges to include shipment info for the presentation component
    const items = useMemo(() => {
        return (charges || []).map((charge) => (Object.assign(Object.assign({}, charge), { shipment: shipment
                ? { _id: shipment._id, shipment_id: shipment.shipment_id }
                : { _id: shipmentId }, adjustment_id: charge._id })));
    }, [charges, shipmentId, shipment]);
    // Map the toggle callback to match the expected interface
    const handleTogglePaid = useCallback((item) => {
        showConfirmation(item._id, shipmentId, item.payment_status, item.message, formatMoney(item.value, item === null || item === void 0 ? void 0 : item.currency));
    }, [showConfirmation, shipmentId]);
    return (React.createElement("div", { "data-testid": "div-99063d4c" },
        React.createElement(Card, { "data-testid": "div-ca6f5376" },
            React.createElement(CardHeader, null,
                React.createElement(CardTitle, { "data-testid": "h3-a3c28987" }, t('VENDOR_CHARGES'))),
            React.createElement(CardContent, { "data-testid": "div-6f5792f4", className: "overflow-x-auto" },
                React.createElement(VendorPayablesTable, { items: items, total: total, isLegManagementEnabled: isLegManagementEnabled, onTogglePaid: handleTogglePaid })))));
}
VendorPayables.propTypes = {
    charges: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string,
        value: PropTypes.number,
        type: PropTypes.string,
        message: PropTypes.string,
        timestamp: PropTypes.string,
    })),
    total: PropTypes.number,
    shipmentId: PropTypes.string,
    shipment: PropTypes.shape({
        _id: PropTypes.string,
        shipment_id: PropTypes.string,
    }),
    showConfirmation: PropTypes.func,
    isLegManagementEnabled: PropTypes.bool,
};
VendorPayables.defaultProps = {
    total: 0,
    isLegManagementEnabled: false,
};
